import React from 'react';
import Card from '../../components/ui/Card/Card';
import Skeleton from '../../components/ui/Skeleton/Skeleton';
import styles from './ClientDetail.module.css';

const ClientDetailSkeleton: React.FC = () => (
  <div className={styles.page}>
    <Card className={styles.headerBar}>
      <Skeleton width={220} height={26} />
      <div className={styles.headerActions}>
        <Skeleton width={36} height={36} className={styles.skRounded} />
        <Skeleton width={36} height={36} className={styles.skRounded} />
      </div>
    </Card>

    <div className={styles.grid}>
      {[0, 1, 2].map((c) => (
        <Card key={c} className={styles.col}>
          <Skeleton width={90} height={18} />
          <Skeleton width="100%" height={44} className={styles.skRounded} />
          <div className={styles.colList}>
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className={styles.rowItem}>
                <Skeleton width="50%" height={14} />
                <Skeleton width={70} height={22} className={styles.skRounded} />
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default ClientDetailSkeleton;
